import { TemplateType } from '@/api/tax-guide';
import { useEffect } from 'react';

type UseCustomCSSProps = {
  folderName?: string;
  template: TemplateType;
};

function useCustomCSS(props: UseCustomCSSProps): void {
  const { folderName, template } = props;
  useEffect(() => {
    if (folderName && template === 'custom') {
      isValidCSS(`direct_logins/${folderName}/${folderName}_banner.css`);
    } else {
      const path = `direct_logins/shareworks/shareworks_banner.css`;
      loadDynamicCSS(path);
    }
  }, []);

  function isValidCSS(path: string) {
    fetch(path)
      .then(response => {
        if (response.ok) {
          console.log('The CSS file exists!');
          const path = `direct_logins/${folderName}/${folderName}_banner.css`;
          loadDynamicCSS(path);
        } else {
          console.log('The CSS file does not exist!');
        }
      })
      .catch(error => {
        console.error('An error occurred in fetching cssfile:', error);
      });
  }

  function loadDynamicCSS(path: string) {
    const linkElement: HTMLLinkElement = document.createElement('link');
    linkElement.rel = 'stylesheet';
    linkElement.href = path;
    document.head.appendChild(linkElement);
  }
}

export default useCustomCSS;
